import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { SupplyDemandKpiProviders } from "./categoryChartData.types";
import _ from "lodash";
import { fetchSupplyDemandKpiProviders } from "./fetchSupplyDemandKpiProviderChartData";

// const def = { data: [], initialYear: null, latestYear: null };

export const fetchSupplyDemandKpiComparisonChartData: CategoryChartQueryFn = async ({
    categoryChart,
    providers,
    kpis
}: CategoryChartQueryParam): Promise<SupplyDemandKpiProviders> => {
    if (!providers || !providers.length || !categoryChart || !kpis || !kpis?.length) return null;
    const { data: vis, initialYear, latestYear } = await fetchSupplyDemandKpiProviders(providers, kpis);
    if (latestYear == null || initialYear == null || !vis || !vis?.length) return null;

    const { visHeader, visFooter, displayTitle } = categoryChart;

    const visHeaderProcessed = _.template(visHeader?.value ?? "")({
        startYear: initialYear,
        endYear: latestYear === initialYear ? null : latestYear
    });

    const visFooterProcessed = _.template(visFooter?.value ?? "")({
        startYear: initialYear,
        endYear: latestYear === initialYear ? null : latestYear
    });

    const _visHeader =
        !visHeader || visHeader.processed.trim() === ""
            ? null
            : {
                  processed: visHeaderProcessed,
                  value: visHeaderProcessed,
                  format: visHeaderProcessed
              };

    const _visFooter =
        !visFooter || visFooter.processed.trim() === ""
            ? null
            : {
                  processed: visFooterProcessed,
                  value: visFooterProcessed,
                  format: visFooterProcessed
              };

    const ret: SupplyDemandKpiProviders = {
        title: displayTitle,
        footer: null,
        vis: vis?.map(d => {
            return {
                ...(d ?? {}),
                header: _visHeader,
                footer: _visFooter
            };
        })
    };

    return ret;
};
